import React from 'react'
import { HStack, Square } from '@chakra-ui/react'

const ratings = [1, 2, 3, 4, 5]
const Rating = ({ value }) => {
  return (
    <HStack
      alignItems="center"
      justifyContent="center"
      spacing="1px"
    >
      {ratings.map(rating => (
        <Square
          key={rating}
          size="10px"
          bg={rating <= value ? 'brand.textDarkBlue' : 'transparent'}
          border="1px solid"
          borderColor="brand.textDarkBlue"
        />
      ))}
    </HStack>
  )
}

Rating.propTypes = {}

export default React.memo(props => <Rating {...props} />)
